import { useMemo } from 'react';
import { PopoverContentProps } from '@radix-ui/react-popover';
import { ALIGNMENT } from 'ui/selects/constants';
import { HORIZONTAL_ALIGNMENT, VERTICAL_ALIGNMENT } from '../types';

type UseDropdownPopoverAlignmentReturnValue = {
  popoverHorizontalAlignment: PopoverContentProps['align'];
  popoverVerticalAlignment: PopoverContentProps['side'];
};

export const useDropdownPopoverAlignment = (
  horizontalAlignment: HORIZONTAL_ALIGNMENT,
  verticalAlignment: VERTICAL_ALIGNMENT,
): UseDropdownPopoverAlignmentReturnValue => {
  return useMemo<UseDropdownPopoverAlignmentReturnValue>(() => {
    let popoverHorizontalAlignment: UseDropdownPopoverAlignmentReturnValue['popoverHorizontalAlignment'] =
      'end';
    let popoverVerticalAlignment: UseDropdownPopoverAlignmentReturnValue['popoverVerticalAlignment'] =
      'bottom';

    switch (horizontalAlignment) {
      case ALIGNMENT.LEFT:
        popoverHorizontalAlignment = 'start';
        break;

      case ALIGNMENT.RIGHT:
        popoverHorizontalAlignment = 'end';
        break;

      default:
        break;
    }

    switch (verticalAlignment) {
      case ALIGNMENT.UP:
        popoverVerticalAlignment = 'top';
        break;

      case ALIGNMENT.DOWN:
        popoverVerticalAlignment = 'bottom';
        break;

      default:
        break;
    }

    return {
      popoverHorizontalAlignment,
      popoverVerticalAlignment,
    };
  }, [horizontalAlignment, verticalAlignment]);
};
